import React from 'react';

import Button from '@atlaskit/button/default/button';
import { Checkbox } from '@atlaskit/checkbox/checkbox';
import { cssMap } from '@atlaskit/css';
import { Main } from '@atlaskit/navigation-system/layout/main';
import { Panel } from '@atlaskit/navigation-system/layout/panel';
import { PanelSplitter } from '@atlaskit/navigation-system/layout/panel-splitter';
import { Root } from '@atlaskit/navigation-system/layout/root';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';
import {
	PanelBody,
	PanelContainer,
	PanelFooter,
	PanelHeader,
	PanelSubheader,
	PanelTitle,
} from '@atlassian/panel-system';
import { PanelContent } from '@atlassian/panel-system/panel-content';

import { PanelCoverImage } from '../images/panel-cover';

const styles = cssMap({
	mainContent: {
		flex: 1,
		paddingBlockStart: token('space.300'),
		paddingInlineEnd: token('space.300'),
		paddingBlockEnd: token('space.300'),
		paddingInlineStart: token('space.300'),
		backgroundColor: token('color.background.neutral.subtle'),
	},
});

export function ResizingExample(): JSX.Element {
	return (
		<Root>
			<Main>
				<Box xcss={styles.mainContent}>
					<Text>
						Click and drag the left edge of the panel to resize it. The PanelSplitter from
						@atlaskit/navigation-system handles all resize logic.
					</Text>
				</Box>
			</Main>

			<Panel defaultWidth={400} label="Resizable panel">
				<PanelContainer>
					<PanelHeader>
						<PanelTitle>Resizable Panel</PanelTitle>
					</PanelHeader>
					<PanelContent>
						<PanelSubheader title="Subheading title" coverImage={<PanelCoverImage />} />
						<PanelBody>
							<Text>This is a simple example showing the resize functionality.</Text>
						</PanelBody>
					</PanelContent>
					<PanelFooter>
						<Checkbox label="Create another" isChecked={false} onChange={() => {}} />
						<Button appearance="primary" onClick={() => {}}>
							Create
						</Button>
					</PanelFooter>
				</PanelContainer>
				<PanelSplitter label="Resize panel" />
			</Panel>
		</Root>
	);
}

export default ResizingExample;
